import type { CellContext } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { ProjectCardWithInvoices } from "@msuite/utils/types";
import { LastInvoice } from "./last-invoice";
import type { InvoiceData } from "./shared";

/** Props Interface */
interface LastInvoiceCellProps {
	cell: CellContext<ProjectCardWithInvoices, InvoiceData | null>;
}

export function LastInvoiceCell({ cell }: LastInvoiceCellProps) {
	/** Computed */
	const invoiceData = cell.getValue();

	/** Render */
	if (!invoiceData?.hasInvoice) return <LastInvoice.NoInvoicesItem />;
	if (invoiceData.hasFinalInvoice) return <LastInvoice.FinalInvoiceItem />;
	if (invoiceData.hasProgressInvoice) {
		const lastMoment = moment(invoiceData.lastInvoiceCalculatedTo);
		const nextMoment = moment(invoiceData.nextPossibleInvoice);
		const lastMomentIsValid = lastMoment.isValid();
		const nextMomentIsValid = nextMoment.isValid();
		const isOverdue = nextMoment.isBefore(moment());

		return (
			<LastInvoice.ProgressInvoiceItem
				last={lastMomentIsValid ? lastMoment.dateFormat() : guardString(null)}
				next={nextMomentIsValid ? nextMoment.dateFormat() : guardString(null)}
				isOverdue={isOverdue ? true : undefined}
			/>
		);
	}
	if (invoiceData.hasSingleInvoice) return <LastInvoice.SingleInvoiceItem />;
	return <LastInvoice.NoInvoicesItem />;
}
